import { apiClient } from '../ApiClient';
import { ApiResponse } from '../ApiClient/types';
import { InternetUserSummary, MfaSetupResponse } from './types';

class UsersService {
    async getAll(): Promise<ApiResponse<InternetUserSummary[]>> {
        return apiClient.get<InternetUserSummary[]>('/users');
    }

    async enableMfa(id: number): Promise<ApiResponse<MfaSetupResponse>> {
        return apiClient.post<MfaSetupResponse>(`/users/${id}/mfa/enable`);
    }

    async disableMfa(id: number): Promise<ApiResponse<string>> {
        return apiClient.post<string>(`/users/${id}/mfa/disable`);
    }
}

export { UsersService };
